var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 14",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4387 3.90599C14.4454 4.04216 14.4479 4.18001 14.4479 4.31619C14.4479 8.51068 11.2562 13.3457 5.4201 13.3457C3.62714 13.3457 1.96027 12.8203 0.555664 11.9192C1.38647 12.0197 2.22894 11.9555 3.0349 11.7302C3.84087 11.5049 4.59453 11.123 5.25282 10.6062C4.5908 10.5937 3.94923 10.3747 3.41782 9.97964C2.88641 9.58462 2.49172 9.03342 2.28894 8.40309C2.76476 8.49207 3.25446 8.4734 3.72213 8.34845C3.00395 8.20282 2.3582 7.81336 1.89433 7.24608C1.43045 6.6788 1.17697 5.96858 1.17685 5.23578V5.19628C1.61748 5.44139 2.11029 5.5777 2.61424 5.59387C1.94167 5.14549 1.46557 4.45734 1.28312 3.66987C1.10066 2.8824 1.2256 2.05499 1.63245 1.35651C2.42914 2.33701 3.42318 3.13896 4.54999 3.71026C5.67681 4.28156 6.91121 4.60944 8.173 4.67259C8.11841 4.43523 8.09105 4.19242 8.09146 3.94886C8.09146 3.5323 8.17352 3.11982 8.33296 2.73498C8.49239 2.35014 8.72608 2.00048 9.02067 1.70596C9.31526 1.41145 9.66498 1.17786 10.0499 1.01852C10.4347 0.85919 10.8472 0.777238 11.2638 0.777348C11.6979 0.77664 12.1276 0.865138 12.5261 1.03735C12.9246 1.20957 13.2835 1.46182 13.5804 1.77848C14.2908 1.63785 14.9722 1.37748 15.5953 1.00851C15.3583 1.74335 14.8624 2.36707 14.2 2.76364C14.8289 2.68907 15.4432 2.52077 16.0223 2.26433C15.5969 2.90186 15.0605 3.45789 14.4387 3.90599Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.671a5413b234808d3ec3b3b6c3c1d7ef.svg";
export { ForwardRef as ReactComponent };